<template>
  <div class="d-flex justify-content-center align-items-center" style="min-height: 60vh">
    <p class="text-muted">Connexion en cours...</p>
  </div>
</template>

<script>
import { onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import api from "@/utils/axios";
import { useAuthStore } from "@/stores/auth";
import { useAppToast } from "@/composables/useAppToast";

export default {
  name: "HashLoginPage",

  setup() {
    const route = useRoute();
    const router = useRouter();
    const { showToast } = useAppToast();

    onMounted(async () => {
      try {
        const auth = useAuthStore();
        const response = await api.post("/api/auth/authBylHash", {
          id: route.params.id,
          user_id: route.params.userId,
        });

        if (response.data && response.data.msg === "success") {
          auth.setToken(response.data.access_token);
          auth.setUser(response.data.user);
          auth.setPermissions(response.data.permissions);

          router.push("/").then(() => {
            window.location.reload();
          });
        } else {
          showToast("Lien de connexion invalide ou expiré", "error");
          router.push({ name: "LoginPage" });
        }
      } catch (error) {
        console.error("Hash login failed:", error.response?.data || error.message);
        showToast("Lien de connexion invalide ou expiré", "error");
        router.push({ name: "LoginPage" });
      }
    });

    return {};
  },
};
</script>
